
import Promise from "plugins/bluebird"
import _once from "lodash/once"

const _onLoad = _once(() => {
  // Too much blocking time running these in a single task
  setTimeout(() => {
    Promise.resolve(
      import(
        "./prompt_modal/last_save_search_notice"
      )
    )
    .then(({default: LastSaveNotice}) => {
      LastSaveNotice.show()
    })
  })
  setTimeout(() => {
    Promise.resolve(
      import(
        "./prompt_modal/save/index"
      )
    )
    .then(({default: SavedPromptModalSave}) => {
      SavedPromptModalSave.init()
    })
  })
  setTimeout(() => {
    Promise.resolve(
      import(
        "./button/save_search_button"
      )
    )
    .then(({default: save_search_button}) => {
      save_search_button.init()
    })
  })
})

const onLoad = () => {
  // Do this after LCP to avoid affecting LCP metric
  import(
    "app/deferred_task_executor/spacious_post_lcp_tasks/scheduler"
  )
  .then(({addPostLCPTaskOrRun}) => {
    addPostLCPTaskOrRun(_onLoad)
  })

  // This is a fallback in case LCP is supported but
  // `getLCP` is bugged/fired really late
  // (Already happening sometimes)
  window.addEventListener("load", _onLoad)
}

export default {onLoad}
